import { createSelector } from "@reduxjs/toolkit";

import type { State } from "@/store/types";

interface SelectionState {
  assetSelection: State["assetSelection"];
}

const initialState = {
  assetCategorySelection: {},
  assetItemSelection: {},
  assetCategoryExpandedSelection: {},
  otherAssetCategorySelection: {},
  otherAssetCategoryExpandedSelection: {},
  organizationPropertySelection: {},
  organizationPropertyExpandedSelection: {},
};

export const assetSelectionSelector = createSelector(
  (state: SelectionState) => state.assetSelection,
  (data) => ({ ...initialState, ...data }),
);
